import * as Scrivito from "scrivito";
import { buttonColors } from "^/config/attributeConsts";

const ButtonWidget = Scrivito.provideWidgetClass("ButtonWidget", {
  attributes: {
    target: "link",
    alignment: ["enum", { values: ["start", "center", "end", "full-width"] }],
    style: [
      "enum",
      {
        values: buttonColors,
      },
    ],
    fallbacktitle: "string",
    noMargin: "boolean",
  },
});

export default ButtonWidget;
